import {$, $$, getParentElementByTagName, hide, show} from "./Dom.ts";

export const removeUndefined = (obj: any): any => {
    let newObj: any = {};
    Object.keys(obj).forEach((key) => {
        if (obj[key] === Object(obj[key])) newObj[key] = removeUndefined(obj[key]);
        else if (obj[key] !== undefined) newObj[key] = obj[key];
    });
    return newObj;
}

export const formatDateToISO = (date: Date) => {
    const mois = String(date.getMonth() + 1).padStart(2, '0')
    const jours = String(date.getDate()).padStart(2, '0')
    const heures = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    return `${date.getFullYear()}-${mois}-${jours}T${heures}:${minutes}`
}

export const updateDateFinPlus4An = (date_debut: HTMLInputElement, date_fin: HTMLInputElement) => {
    const dateDebut = date_debut.value
    const newDateFin = new Date(dateDebut)
    newDateFin.setFullYear(newDateFin.getFullYear() + 4)
    date_fin.value = formatDateToISO(newDateFin)
    // @ts-ignore
    if (date_fin._flatpickr) {
        // @ts-ignore
        date_fin._flatpickr.setDate(newDateFin, true, "d-m-Y")
    }
}


export const findElementUnique = (test: any[], ...arrays: any[]) => {
    // others is the Set of all value in the other arrays
    const others = arrays.reduce((accum, elem) => {
        if (elem != test) {
            elem.forEach(accum.add, accum)
        }
        return accum
    }, new Set())
    // find anything in the test array that the others do not have
    return [...new Set(test.filter(value => !others.has(value)))]
}


export const arrayIntersect = (arr1: any[], arr2: any[], accessors = [(v: any) => v, (v: any) => v]) => {
    const [fn1, fn2] = accessors;
    const set = new Set(arr2.map(v => fn2(v)));
    return arr1.filter(value => set.has(fn1(value)));
};


export const scroll_to = (element: HTMLElement | string | null, options: boolean | ScrollIntoViewOptions = true) => {
    if (typeof element === 'string') {
        element = $<HTMLElement>(element)
    }
    if (element) element.scrollIntoView(options)
}

export function initMatomo() {
    var _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(["setCookieDomain", "*.www.declaration-manifestations.gouv.fr"]);
    _paq.push(["setExcludedQueryParams", ["http:\/\/localhost\/","http:\/\/127.0.0.1\/","http:\/\/localhost:8000\/","http:\/\/127.0.0.1:8000\/","https:\/\/localhost\/","https:\/\/127.0.0.1\/","https:\/\/localhost:8000\/","https:\/\/127.0.0.1:8000\/"]]);
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
    var u="https://openscop.icu/";
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '2']);
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src=u+'matomo.js'; s.parentNode?.insertBefore(g,s);
    })();
}


export function envoyerPageAMatomo(pageTitle: string) {
    if (!window._paq) {
        initMatomo()
    }
    window._paq.push(['setCustomUrl', '/' + window.location.hash]);
    window._paq.push(['setDocumentTitle', pageTitle]);
    window._paq.push(['trackPageView']);
}

export function envoyerLienMatomo(categorie: string, nom: string, method: string|undefined) {
    if (!window._paq) {
        initMatomo()
    }
    window._paq.push(['trackEvent', categorie, nom, method]);
}

export function refreshPage() {
    window.location.reload()
}

export function enableHabilitationAvanceesButton() {
    $("#habilitations-avancees-link")?.addEventListener('click', function (event: Event) {
        show($<HTMLElement>("#habilitations-avancees"))
        hide((event.target as HTMLElement))
    })
}

export function findCkeditorInstance(id:string){
    const textareas = Array.from(document.querySelectorAll( '.ck-editor__editable_inline' ))
    // @ts-ignore
    const textarea = textareas.find(textarea => textarea.ckeditorInstance.sourceElement.id === id)
    // @ts-ignore
    return textarea.ckeditorInstance
}

export function resetAllOptionsWithName(name: string) {
    Array.from($$<HTMLInputElement>(`input[name="${name}"]:checked`), input => input.checked = false);
}

export function getAttributeOrUndefined(element: HTMLElement, attribute: string) {
    if(element.hasAttribute(attribute)) return element.getAttribute(attribute) as string
    return undefined
}

export function checkIfDateIsBefore(dateStart: Date, dateEnd: Date) {
    return dateStart.getTime() < dateEnd.getTime()
}

export function checkIfDateIsLessThan365Days(dateStart: Date, dateEnd: Date) {
    return Math.round(( dateEnd.getTime() - dateStart.getTime() ) / ( 1000 * 3600 * 24 )) < 365
}

export function createDateFromStringOrNull(value: string): Date|null {
    try {
        return new Date(value)
    } catch (e) {
        console.error("error convertion date : ", e)
    }
    return null
}

export function checkIfDateIsFutur(date: Date) {
    return date > new Date()
}


export function deplier_tous_accordeons(event: DOMEvent<HTMLElement>) {
    const target = getParentElementByTagName(event.target, "button")
    if(!target) return

    let querySelector = '.openscop-tabs .openscop-tabs__panel:not(.d-none) .fr-accordion__btn[aria-expanded="false"]'
    let text = '<i class="remix-tout-deplier" aria-hidden="true"></i>Tout replier'
    if(target.hasAttribute('data-open')) {
        text = '<i class="remix-tout-deplier" aria-hidden="true"></i>Tout déplier'
        querySelector = '.openscop-tabs .openscop-tabs__panel:not(.d-none) .fr-accordion__btn[aria-expanded="true"]'
    }
    target.toggleAttribute('data-open')

    $$(querySelector).forEach(button => button.click());
    target.innerHTML = text
}

